interface SectionHeadingProps {
  kicker: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
  accent?: boolean;
}

export default function SectionHeading({
  kicker,
  title,
  desc,
  align = "left",
  accent = false,
}: SectionHeadingProps) {
  const centered = align === "center";
  return (
    <div className={`max-w-2xl ${centered ? "mx-auto text-center" : ""}`}>
      <span
        className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-3 py-1 text-xs font-medium ${
          accent ? "bg-accent-100 text-accent-700" : "bg-secondary-100 text-secondary-800"
        }`}
      >
        <i className="ri-sparkling-2-fill text-sm" aria-hidden="true"></i>
        {kicker}
      </span>
      <h2 className="mt-4 text-2xl font-bold tracking-tight text-foreground-950 md:text-4xl">{title}</h2>
      {desc && <p className="mt-3 text-sm leading-relaxed text-foreground-700 md:text-base">{desc}</p>}
    </div>
  );
}